import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';

import {ReviewRoutingModule} from './review-routing.module';
import {CreateReviewDialogComponent} from './create-review-dialog/create-review-dialog.component';
import {MatDialogModule} from "@angular/material/dialog";
import {NgxDropzoneModule} from "ngx-dropzone";
import {MatIconModule} from "@angular/material/icon";
import {PipeModule} from "../pipe/pipe.module";
import {ReactiveFormsModule} from "@angular/forms";
import {ReviewListComponent} from './review-list/review-list.component';
import {ReviewPreviewCardComponent} from './review-preview-card/review-preview-card.component';
import {ReviewComponent} from './review/review.component';


@NgModule({
	declarations: [
		CreateReviewDialogComponent,
		ReviewListComponent,
		ReviewPreviewCardComponent,
		ReviewComponent
	],
	imports: [
		CommonModule,
		ReviewRoutingModule,
		MatDialogModule,
		NgOptimizedImage,
		NgxDropzoneModule,
		MatIconModule,
		PipeModule,
		ReactiveFormsModule
	],
	exports: [
		CreateReviewDialogComponent,
		ReviewListComponent
	]
})
export class ReviewModule {
}
